export const MAX_RESULTS = 8;
